"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _excluded = ["title", "href", "depth", "children", "icon", "className", "open", "label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CustomRouterLink = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, props));
});
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    item: {
      display: "block",
      paddingTop: 0,
      paddingBottom: 0
    },
    itemLeaf: {
      display: "flex",
      paddingTop: 0,
      paddingBottom: 0
    },
    button: {
      //color: colors.blueGrey[800],
      color: theme.palette.text.primary,
      padding: "10px 8px",
      justifyContent: "flex-start",
      textTransform: "none",
      letterSpacing: 0,
      width: "100%"
    },
    buttonLeaf: {
      //color: colors.blueGrey[800],
      color: theme.palette.text.secondary,
      padding: "10px 8px",
      justifyContent: "flex-start",
      textTransform: "none",
      letterSpacing: 0,
      width: "100%",
      fontWeight: theme.typography.fontWeightRegular,
      "&.depth-0": {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    icon: {
      color: theme.palette.icon,
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(1)
    },
    expandIcon: {
      marginLeft: "auto",
      height: 16,
      width: 16
    },
    label: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto"
    },
    active: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      "& $icon": {
        color: theme.palette.primary.main
      }
    }
  };
});

var NavigationListItem = function NavigationListItem(props) {
  var title = props.title,
      href = props.href,
      depth = props.depth,
      children = props.children,
      Icon = props.icon,
      className = props.className,
      openProp = props.open,
      Label = props.label,
      rest = _objectWithoutProperties(props, _excluded);

  var classes = useStyles();

  var _useState = (0, _react.useState)(openProp),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleToggle = function handleToggle() {
    setOpen(function (open) {
      return !open;
    });
  };

  var paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  var style = {
    paddingLeft: paddingLeft
  };

  if (children) {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, _extends({}, rest, {
      className: (0, _clsx["default"])(classes.item, className),
      disableGutters: true
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      className: classes.button,
      onClick: handleToggle,
      style: style
    }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), title, open ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], {
      className: classes.expandIcon,
      color: "inherit"
    }) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
      className: classes.expandIcon,
      color: "inherit"
    })), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
      "in": open
    }, children));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, _extends({}, rest, {
      className: (0, _clsx["default"])(classes.itemLeaf, className),
      disableGutters: true
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      activeClassName: classes.active,
      className: (0, _clsx["default"])(classes.buttonLeaf, "depth-".concat(depth)),
      component: CustomRouterLink,
      exact: true,
      style: style,
      to: href
    }, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
      className: classes.icon
    }), title, Label && /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.label
    }, /*#__PURE__*/_react["default"].createElement(Label, null))));
  }
};

NavigationListItem.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  depth: _propTypes["default"].number.isRequired,
  href: _propTypes["default"].string,
  icon: _propTypes["default"].any,
  label: _propTypes["default"].any,
  open: _propTypes["default"].bool,
  title: _propTypes["default"].string.isRequired
};
NavigationListItem.defaultProps = {
  depth: 0,
  open: false
};
var _default = NavigationListItem;
exports["default"] = _default;